import ErrorMsg from './ErrorMsg';

export default ErrorMsg;
